import { useState, useEffect, useCallback } from 'react';
import { webhookConfig } from '../config/webhookConfig';
import { WebhookConfig, WebhookSettings } from '../types';

export const useWebhookConfig = () => {
  const [settings, setSettings] = useState<WebhookSettings>(webhookConfig.getSettings());
  const [isValid, setIsValid] = useState(webhookConfig.isValid());

  // 설정 업데이트
  const updateSettings = useCallback((newConfig: Partial<WebhookConfig>) => {
    webhookConfig.updateSettings(newConfig);
    setSettings(webhookConfig.getSettings());
    setIsValid(webhookConfig.isValid());
  }, []);

  // 설정 초기화
  const resetSettings = useCallback(() => {
    webhookConfig.reset();
    setSettings(webhookConfig.getSettings());
    setIsValid(webhookConfig.isValid());
  }, []);

  // 특정 웹훅 URL 가져오기
  const getWebhookUrl = useCallback((type: 'contact' | 'analytics' | 'batch') => {
    return webhookConfig.getWebhookUrl(type);
  }, []);

  // 특정 웹훅 URL이 설정되어 있는지 확인
  const hasWebhookUrl = useCallback((type: 'contact' | 'analytics' | 'batch') => {
    return webhookConfig.hasWebhookUrl(type);
  }, []);

  // 설정 변경 감지
  useEffect(() => {
    const handleStorageChange = () => {
      setSettings(webhookConfig.getSettings());
      setIsValid(webhookConfig.isValid());
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return {
    settings,
    isValid,
    updateSettings,
    resetSettings,
    getWebhookUrl,
    hasWebhookUrl,
  };
}; 